import orderBy from 'lodash/orderBy';

export const tableInitialState = {
	columns: {
		date: {
			id: 'date',
			position: 'date',
			title: 'Время'
		},
		offer: {
			id: 'offer',
			direction: 'desc',
			title: 'Офферы'
		},
		campaign: {
			id: 'campaign',
			position: 'campaign',
			title: 'Потоки'
		},
		payload: {
			id: 'payload',
			position: 'payload',
			colSpan: 1,
			title: 'Запрос'
		},
		type: {
			id: 'type',
			position: 'type',
			colSpan: 1,
			title: 'Тип'
		}
	},
	detailsIndex: null,
	isPlayed: false
};

export const transformRows = (rows, sortByColumn) => {
	return sortColumns(rows, sortByColumn);
};

const sortColumns = (rows, sortByColumn) => {
	if (!rows) return null;
	if (!sortByColumn) return rows;
	return orderBy(
		rows,
		row => {
			const value = row[sortByColumn.key];
			switch (sortByColumn.key) {
				case 'sid':
					return getSids(row);
				case 'payout':
					return parseFloat(value);
				case 'location':
					return row.country;
				default:
					return value;
			}
		},
		sortByColumn.direction
	);
};

export const getSids = row => {
	const keys = ['sid1', 'sid2', 'sid3', 'sid4', 'sid5'];
	return keys.map(key => row[key]).filter(sid => !!sid).join(':');
};



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/statistics/components/table/auto-trash/index.js